<template>
  <div id="app">
    <cookie-consent />
    <router-view/>
  </div>
</template>

<script>
import Head from './components/layout/head.vue'
import Bottom from './components/layout/bottom.vue'
import store from './store/index'
import cookieConsent from '@/components/cookieConsent';
export default {
  components: {
    Head,
    Bottom,
    cookieConsent
  },
  data() {
    return {}
  },
  watch: {
    offsetWidth(val, oldVal) {
      if (val !== oldVal) {
        location.reload()
      }
    }
  },
  methods: {
    setClient() {
      const screenWidth = document.body.offsetWidth
      if (screenWidth < 980) {
        store.dispatch('toggleScreen', false)
      } else {
        store.dispatch('toggleScreen', true)
      }
    }
  },
  created() {
    // 页面加载时检查当前路由
    const currentPath = this.$route.path
    if (currentPath === '/' || currentPath === '') {
      // 如果是根路径，立即重定向到 error 页面
      this.$router.replace('/error')
    }
  },
  mounted() {
    this.setClient()
  }
}
// This starter template is using Vue 3 experimental <script setup> SFCs
// Check out https://github.com/vuejs/rfcs/blob/master/active-rfcs/0040-script-setup.md
</script>
<style lang="less">
#app {
  width: 100%;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
html, body {
  min-height: 100%;
  font-size: 16px;
  margin: 0;
  padding: 0;
  // background-color: #F6F6F6;
  background: #F6F6F6;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
p, ul {
  margin: 0;
  padding: 0;
}
</style>
